import { render } from "./BottomContacts.vue?vue&type=template&id=06a6ebe2&scoped=true"
import script from "./BottomContacts.vue?vue&type=script&lang=js"
export * from "./BottomContacts.vue?vue&type=script&lang=js"

import "./BottomContacts.vue?vue&type=style&index=0&id=06a6ebe2&scoped=true&lang=css"

import exportComponent from "D:\\FreedomLk\\legal-client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-06a6ebe2"]])

export default __exports__